<template>
  <div>
    <div v-if="audioPlayer.showAudioPlayer" id="audio-player" class="audio-player">
      <div v-if="view == 'desktop'" class="audio-player__container">
        <div class="track-info">
          <div class="track-info-text">
            <a href="#" class="track-show" @click.stop="goToPodcast">{{ audioPlayer.author }}</a>
            <div class="track-name truncate">Episode {{ audioPlayer.episodeIndex }}. {{ audioPlayer.title }}</div>
          </div>
        </div>
        <div class="audio-play-controls">
          <a href="#" class="track-control-prev button-animation" @click.prevent="buttonClick('controlPrev')">
            <i class="icon-prev" />
          </a>
          <a
            v-if="currentPlayObject.playState === 'paused'"
            href="#"
            class="track-control-play"
            @click="buttonClick('controlPlayPause', 'playing')"
          >
            <i class="icon-play" />
          </a>
          <a
            v-if="currentPlayObject.playState !== 'paused'"
            href="#"
            class="track-control-play"
            @click="buttonClick('controlPlayPause', 'paused')"
          >
            <i class="icon-pause" />
          </a>
          <a href="#" class="track-control-next button-animation" @click.prevent="buttonClick('controlNext')">
            <i class="icon-prev" />
          </a>
        </div>
        <div class="audio-player-progress">
          <vue-slider
            v-model="rangeSlider.current"
            tooltip="none"
            :max="audioPlayer.durationInSeconds"
            :lazy="true"
            @click.native="rangeSliderEvent('click')"
            @change="seekSelect"
            @drag-start="rangeSliderEvent('start')"
            @drag-end="rangeSliderEvent('stop', $event)"
          />
          <span class="track-time">
            <span class="audio-current-time">
              {{ audioPlayer.playerEpisodeCurrentTime }}
            </span>
            <span class="audio-total-time">
              {{ audioPlayer.playerEpisodeDuration }}
            </span>
          </span>
        </div>
        <div class="volume-slider">
          <div class="dropup afripods-dropup">
            <button
              id="dropdownMenu3"
              class="btn btn-default dropdown-toggle sm-button"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11 5L6 9H2V15H6L11 19V5Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.07 4.92993C20.9447 6.80521 21.9978 9.34829 21.9978 11.9999C21.9978 14.6516 20.9447 17.1947 19.07 19.0699M15.54 8.45993C16.4773 9.39757 17.0039 10.6691 17.0039 11.9949C17.0039 13.3208 16.4773 14.5923 15.54 15.5299"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <div class="dropdown-menu afripods-dropup-menu volume-slider-range" aria-labelledby="dropdownMenu3">
              <input
                v-model="audioPlayer.volume"
                type="range"
                min="0"
                max="100"
                class="slider"
                @change="volumeControl"
              />
            </div>
          </div>
          <div class="dropup afripods-dropup">
            <button
              id="dropdownMenu4"
              class="btn btn-default dropdown-toggle sm-button"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ player.playbackRate }}x
            </button>
            <div class="dropdown-menu afripods-dropup-menu speed-menu" aria-labelledby="dropdownMenu4">
              <div class="speed-slider">
                <input
                  v-model="audioPlayer.speed"
                  type="range"
                  min="1"
                  max="9"
                  step="1"
                  value="3"
                  class="slider"
                  @change="speedControl"
                />
              </div>
              <ul>
                <li>
                  <span @click="speedControlToggle('9')">3x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('8')">2.5x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('7')">2x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('6')">1.75x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('5')">1.5x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('4')">1.25x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('3')">1x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('2')">0.75x</span>
                </li>
                <li>
                  <span @click="speedControlToggle('1')">0.5x</span>
                </li>
              </ul>
            </div>
          </div>
          <button id="like-btn" @click="handleSave()">
            <svg
              v-if="!episodeSaved"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
                stroke="#FDD366"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg v-else width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z"
                fill="#FDD366"
                stroke="#FDD366"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <div class="dropup afripods-dropup">
            <button
              id="dropdownMenu2"
              class="btn btn-default dropdown-toggle sm-button"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fa fa-share-alt" aria-hidden="true" />
            </button>
            <ul class="dropdown-menu afripods-dropup-menu social-share-menu" aria-labelledby="dropdownMenu2">
              <div>
                <li class="afripods-sm-item">
                  <social-sharing :url="socialShareLink" inline-template>
                    <network network="email">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="16" fill="white" />
                        <path
                          d="M10 10H22C22.825 10 23.5 10.675 23.5 11.5V20.5C23.5 21.325 22.825 22 22 22H10C9.175 22 8.5 21.325 8.5 20.5V11.5C8.5 10.675 9.175 10 10 10Z"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M23.5 11.5L16 16.75L8.5 11.5"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Email
                    </network>
                  </social-sharing>
                </li>

                <li class="afripods-sm-item" @click="copyUrl">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="16" r="16" fill="white" />
                    <path
                      d="M14.5 16.75C14.8221 17.1806 15.233 17.5369 15.7049 17.7947C16.1768 18.0525 16.6986 18.2058 17.235 18.2443C17.7713 18.2827 18.3097 18.2053 18.8135 18.0173C19.3173 17.8294 19.7748 17.5353 20.155 17.155L22.405 14.905C23.0881 14.1977 23.4661 13.2505 23.4575 12.2672C23.449 11.284 23.0546 10.3435 22.3593 9.64818C21.664 8.9529 20.7235 8.55852 19.7403 8.54998C18.757 8.54143 17.8098 8.91941 17.1025 9.6025L15.8125 10.885"
                      stroke="#1D1F24"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5 15.25C17.1779 14.8194 16.767 14.4631 16.2951 14.2053C15.8232 13.9475 15.3014 13.7941 14.765 13.7557C14.2287 13.7173 13.6903 13.7947 13.1865 13.9826C12.6827 14.1706 12.2252 14.4647 11.845 14.845L9.59503 17.095C8.91194 17.8022 8.53396 18.7495 8.5425 19.7327C8.55104 20.716 8.94543 21.6565 9.64071 22.3518C10.336 23.0471 11.2765 23.4415 12.2598 23.45C13.243 23.4586 14.1903 23.0806 14.8975 22.3975L16.18 21.115"
                      stroke="#1D1F24"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Link
                </li>

                <li class="afripods-sm-item">
                  <social-sharing :url="socialShareLink" inline-template>
                    <network network="facebook">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="14" fill="#1D1F24" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M20.155 10.656L18.649 10.657C17.468 10.657 17.239 11.218 17.239 12.041V13.857H20.056L19.689 16.702H17.239V24H14.302V16.702H11.846V13.857H14.302V11.76C14.302 9.325 15.789 8 17.96 8C19 8 19.894 8.077 20.155 8.112V10.656ZM16 0C7.164 0 0 7.163 0 16C0 24.836 7.164 32 16 32C24.837 32 32 24.836 32 16C32 7.163 24.837 0 16 0Z"
                          fill="white"
                        />
                      </svg>
                      Facebook
                    </network>
                  </social-sharing>
                </li>
                <li class="afripods-sm-item">
                  <social-sharing :url="socialShareLink" inline-template>
                    <network network="linkedin">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="16" fill="white" />
                        <path
                          d="M19 13C20.1935 13 21.3381 13.4741 22.182 14.318C23.0259 15.1619 23.5 16.3065 23.5 17.5V22.75H20.5V17.5C20.5 17.1022 20.342 16.7206 20.0607 16.4393C19.7794 16.158 19.3978 16 19 16C18.6022 16 18.2206 16.158 17.9393 16.4393C17.658 16.7206 17.5 17.1022 17.5 17.5V22.75H14.5V17.5C14.5 16.3065 14.9741 15.1619 15.818 14.318C16.6619 13.4741 17.8065 13 19 13V13Z"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.5 13.75H8.5V22.75H11.5V13.75Z"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      LinkedIn
                    </network>
                  </social-sharing>
                </li>
                <li class="afripods-sm-item">
                  <social-sharing :url="socialShareLink" inline-template>
                    <network network="twitter">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="16" fill="white" />
                        <path
                          d="M25.25 9.25C24.5318 9.75661 23.7366 10.1441 22.895 10.3975C22.4433 9.87814 21.843 9.51002 21.1753 9.34295C20.5076 9.17587 19.8046 9.2179 19.1616 9.46334C18.5185 9.70879 17.9663 10.1458 17.5797 10.7153C17.1931 11.2848 16.9908 11.9593 17 12.6475V13.3975C15.682 13.4317 14.376 13.1394 13.1983 12.5466C12.0206 11.9538 11.0077 11.079 10.25 10C10.25 10 7.25 16.75 14 19.75C12.4554 20.7985 10.6154 21.3242 8.75 21.25C15.5 25 23.75 21.25 23.75 12.625C23.7493 12.4161 23.7292 12.2077 23.69 12.0025C24.4555 11.2476 24.9956 10.2945 25.25 9.25Z"
                          stroke="#1D1F24"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Twitter
                    </network>
                  </social-sharing>
                </li>
              </div>
            </ul>
          </div>
          <div class="dropup afripods-dropup">
            <button
              id="dropdownMenu6"
              class="btn btn-default dropdown-toggle sm-button btn-close"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              ⋮
            </button>
            <div
              class="dropdown-menu afripods-dropup-menu social-share-menu close-menu"
              aria-labelledby="dropdownMenu6"
            >
              <a id="player-close" href="#" @click="closePlayer">Close player</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="view == 'mobile'" class="audio-player__container audio-player-mobile">
        <div
          v-if="viewSize !== 'fullscreen'"
          class="mobile-audioplayer-fullscreen"
          @click.prevent="mediaPlayerFullscreen"
        />
        <div v-if="viewSize == 'fullscreen'" class="mobile-player-close">
          <span class="chevron" @click.stop="minimizeFullscreen">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span class="media-player-close" @click="closePlayer">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
          </span>
        </div>
        <div
          v-if="viewSize == 'fullscreen'"
          class="track-image bg bg-cover"
          :style="{ backgroundImage: 'url(' + audioPlayer.image + ')' }"
        />
        <div class="track-info" @click.prevent="trackInfoClick">
          <div class="track-info-text">
            <span class="track-show" @click.stop="goToPodcast">{{ audioPlayer.author }}</span>
            <div class="track-name truncate">Episode {{ audioPlayer.episodeIndex }}. {{ audioPlayer.title }}</div>
          </div>
        </div>
        <div class="audio-player-progress">
          <vue-slider
            v-model="rangeSlider.current"
            tooltip="none"
            :max="audioPlayer.durationInSeconds"
            :lazy="true"
            @change="seekSelect"
            @click.native="rangeSliderEvent('click')"
            @drag-start="rangeSliderEvent('start')"
            @drag-end="rangeSliderEvent('stop')"
          />
          <span v-if="viewSize == 'fullscreen'" class="track-time">
            <span class="audio-current-time">
              {{ audioPlayer.playerEpisodeCurrentTime }}
            </span>
            <span class="audio-total-time">
              {{ audioPlayer.playerEpisodeDuration }}
            </span>
          </span>
        </div>

        <div class="audio-play-controls">
          <a href="#" class="track-control-prev button-animation" @click.stop="buttonClick('controlPrev')">
            <i class="icon-prev" />
          </a>
          <a
            v-if="currentPlayObject.playState === 'paused'"
            href="#"
            class="track-control-play"
            @click="buttonClick('controlPlayPause', 'playing')"
          >
            <i class="icon-play" />
          </a>
          <a
            v-if="currentPlayObject.playState !== 'paused'"
            href="#"
            class="track-control-play"
            @click="buttonClick('controlPlayPause', 'paused')"
          >
            <i class="icon-pause" />
          </a>
          <a href="#" class="track-control-next button-animation" @click.stop="buttonClick('controlNext')">
            <i class="icon-prev" />
          </a>
        </div>
        <div v-if="viewSize == 'fullscreen'" class="volume-slider-mobile">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.3335 1.3335L4.00016 4.00016H1.3335V8.00016H4.00016L7.3335 10.6668V1.3335Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input v-model="audioPlayer.volume" type="range" min="0" max="100" class="slider" @change="volumeControl" />

          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
              <path
                d="M7.3335 3.3335L4.00016 6.00016H1.3335V10.0002H4.00016L7.3335 12.6668V3.3335Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.7132 3.28662C13.963 4.53681 14.6651 6.23219 14.6651 7.99995C14.6651 9.76772 13.963 11.4631 12.7132 12.7133M10.3599 5.63995C10.9848 6.26505 11.3358 7.11274 11.3358 7.99662C11.3358 8.8805 10.9848 9.7282 10.3599 10.3533"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </div>
        <div v-if="viewSize == 'fullscreen'" class="speed-bookmark-share">
          <div id="speed-menu">
            <button class="menu-back" @click="speedMenuClose">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </button>
            <div class="speed-menu-content">
              <h3 class="mobile-menu-headline">Change speed</h3>
              <div class="speed-picker">
                <div class="row">
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="1" />
                    <span>0.5x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="2" />
                    <span>0.75x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="3" />
                    <span>1x</span>
                  </label>
                </div>
                <div class="row">
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="4" />
                    <span>1.25x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="5" />
                    <span>1.5x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="6" />
                    <span>1.75x</span>
                  </label>
                </div>
                <div class="row">
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="7" />
                    <span>2x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="8" />
                    <span>2.5x</span>
                  </label>
                  <label>
                    <input v-model="audioPlayer.speedRadio" type="radio" name="speedRadio" value="9" />
                    <span>3x</span>
                  </label>
                </div>
              </div>
              <button
                class="btn btn-orange speed-menu-save"
                @click="
                  speedControlToggle(audioPlayer.speedRadio)
                  speedMenuClose()
                "
              >
                <span>Save</span>
                <i class="button-arrow-icon icon-arrow" />
              </button>
            </div>
          </div>
          <div id="mobile-share-menu">
            <button class="menu-back" @click="shareMenuClose">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </button>
            <h3 class="mobile-menu-headline">Share</h3>
            <div class="shared-content">
              <div
                v-if="viewSize == 'fullscreen'"
                class="track-image bg bg-cover"
                :style="{ backgroundImage: 'url(' + audioPlayer.image + ')' }"
              />
              <div class="track-info-text">
                <div class="track-name truncate">Episode {{ audioPlayer.episodeIndex }}. {{ audioPlayer.title }}</div>
                <span class="track-show">{{ audioPlayer.author }}</span>
              </div>
            </div>

            <ul>
              <li class="afripods-sm-item">
                <social-sharing :url="socialShareLink" inline-template>
                  <network network="email">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="16" fill="white" />
                      <path
                        d="M10 10H22C22.825 10 23.5 10.675 23.5 11.5V20.5C23.5 21.325 22.825 22 22 22H10C9.175 22 8.5 21.325 8.5 20.5V11.5C8.5 10.675 9.175 10 10 10Z"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M23.5 11.5L16 16.75L8.5 11.5"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Email <i class="button-arrow-icon icon-arrow" />
                  </network>
                </social-sharing>
              </li>
              <li class="afripods-sm-item" @click="copyUrl">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="16" fill="white" />
                  <path
                    d="M14.5 16.75C14.8221 17.1806 15.233 17.5369 15.7049 17.7947C16.1768 18.0525 16.6986 18.2058 17.235 18.2443C17.7713 18.2827 18.3097 18.2053 18.8135 18.0173C19.3173 17.8294 19.7748 17.5353 20.155 17.155L22.405 14.905C23.0881 14.1977 23.4661 13.2505 23.4575 12.2672C23.449 11.284 23.0546 10.3435 22.3593 9.64818C21.664 8.9529 20.7235 8.55852 19.7403 8.54998C18.757 8.54143 17.8098 8.91941 17.1025 9.6025L15.8125 10.885"
                    stroke="#1D1F24"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.5 15.25C17.1779 14.8194 16.767 14.4631 16.2951 14.2053C15.8232 13.9475 15.3014 13.7941 14.765 13.7557C14.2287 13.7173 13.6903 13.7947 13.1865 13.9826C12.6827 14.1706 12.2252 14.4647 11.845 14.845L9.59503 17.095C8.91194 17.8022 8.53396 18.7495 8.5425 19.7327C8.55104 20.716 8.94543 21.6565 9.64071 22.3518C10.336 23.0471 11.2765 23.4415 12.2598 23.45C13.243 23.4586 14.1903 23.0806 14.8975 22.3975L16.18 21.115"
                    stroke="#1D1F24"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Link <i class="button-arrow-icon icon-arrow" />
              </li>
              <li class="afripods-sm-item">
                <social-sharing :url="socialShareLink" inline-template>
                  <network network="facebook">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="14" fill="#1D1F24" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.155 10.656L18.649 10.657C17.468 10.657 17.239 11.218 17.239 12.041V13.857H20.056L19.689 16.702H17.239V24H14.302V16.702H11.846V13.857H14.302V11.76C14.302 9.325 15.789 8 17.96 8C19 8 19.894 8.077 20.155 8.112V10.656ZM16 0C7.164 0 0 7.163 0 16C0 24.836 7.164 32 16 32C24.837 32 32 24.836 32 16C32 7.163 24.837 0 16 0Z"
                        fill="white"
                      />
                    </svg>
                    Facebook <i class="button-arrow-icon icon-arrow" />
                  </network>
                </social-sharing>
              </li>
              <li class="afripods-sm-item">
                <social-sharing :url="socialShareLink" inline-template>
                  <network network="linkedin">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="16" fill="white" />
                      <path
                        d="M19 13C20.1935 13 21.3381 13.4741 22.182 14.318C23.0259 15.1619 23.5 16.3065 23.5 17.5V22.75H20.5V17.5C20.5 17.1022 20.342 16.7206 20.0607 16.4393C19.7794 16.158 19.3978 16 19 16C18.6022 16 18.2206 16.158 17.9393 16.4393C17.658 16.7206 17.5 17.1022 17.5 17.5V22.75H14.5V17.5C14.5 16.3065 14.9741 15.1619 15.818 14.318C16.6619 13.4741 17.8065 13 19 13V13Z"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.5 13.75H8.5V22.75H11.5V13.75Z"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    LinkedIn <i class="button-arrow-icon icon-arrow" />
                  </network>
                </social-sharing>
              </li>
              <li class="afripods-sm-item">
                <social-sharing :url="socialShareLink" inline-template>
                  <network network="twitter">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="16" fill="white" />
                      <path
                        d="M25.25 9.25C24.5318 9.75661 23.7366 10.1441 22.895 10.3975C22.4433 9.87814 21.843 9.51002 21.1753 9.34295C20.5076 9.17587 19.8046 9.2179 19.1616 9.46334C18.5185 9.70879 17.9663 10.1458 17.5797 10.7153C17.1931 11.2848 16.9908 11.9593 17 12.6475V13.3975C15.682 13.4317 14.376 13.1394 13.1983 12.5466C12.0206 11.9538 11.0077 11.079 10.25 10C10.25 10 7.25 16.75 14 19.75C12.4554 20.7985 10.6154 21.3242 8.75 21.25C15.5 25 23.75 21.25 23.75 12.625C23.7493 12.4161 23.7292 12.2077 23.69 12.0025C24.4555 11.2476 24.9956 10.2945 25.25 9.25Z"
                        stroke="#1D1F24"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Twitter <i class="button-arrow-icon icon-arrow" />
                  </network>
                </social-sharing>
              </li>
            </ul>
          </div>
          <button class="speed-btn" @click="mobileSpeedMenu()">{{ player.playbackRate }}x</button>
          <button class="bookmark-btn" @click="handleSave()">
            <svg
              v-if="!episodeSaved"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.3332 28L15.9998 21.3333L6.6665 28V6.66667C6.6665 5.95942 6.94746 5.28115 7.44755 4.78105C7.94765 4.28095 8.62593 4 9.33317 4H22.6665C23.3737 4 24.052 4.28095 24.5521 4.78105C25.0522 5.28115 25.3332 5.95942 25.3332 6.66667V28Z"
                stroke="#FDD366"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg v-else width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z"
                fill="#FDD366"
                stroke="#FDD366"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button class="share-btn" @click="mobileShareMenu()">
            <svg
              aria-hidden="true"
              class="svg-inline--fa fa-share-alt fa-w-14"
              data-prefix="fa"
              data-icon="share-alt"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              data-fa-i2svg=""
            >
              <path
                fill="currentColor"
                d="M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <audio id="audioplayer" preload="none" />
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import afripodsHttp from '../../api/statistics/statistics'
import auth from '../../auth/index'
import config from '../../conf/index'
import { trackDuration } from '../../filters'
import { event, isValidUrl } from '../../utils/index'
import { StatisticsHelper } from '../../utils/Statistics/StatisticsHelper'
import { AudioPlayer } from './model/AudioPlayer'
import * as DataType from './model/constants/DataType'
import * as ImpressionType from './model/constants/ImpressionType'
import * as ObjectType from './model/constants/ObjectType'
import * as PlayState from './model/constants/PlayState'
import * as WhichObject from './model/constants/WhichObject'
import { AudioPlayerUtils } from './utils/AudioPlayerUtils'

const SocialSharing = require('vue-social-sharing')

export default {
  components: {
    vueSlider,
    SocialSharing,
  },
  /**
   *
   * player - the instance of the audio player retrieved from document.getElementById('audioplayer')
   *
   * audioPlayer - the object which contains the data used by the afripods media player to display data and function correctly.
   *
   * currentPlayObject - the object which contains the data needed for the audio player to play an episode, includes preroll and midroll
   * ads, and other data needed to execute all functions needed in order to play an episode and its ads.
   *
   * playObjects - All playObjects. A playObject is created for each episode in a podcast.
   *
   * ads - all ads, preroll and midroll.
   *
   * https://github.com/NightCatSama/vue-slider-component
   */
  data() {
    return {
      player: '',
      audioPlayer: {},
      currentPlayObject: {},
      playObjects: [],
      socialShareLink: '',
      viewSize: 'default',
      view: 'desktop',
      episodeSaved: false,
      user: {
        userId: '',
      },
      timer: null,
      streamTimer: null,
      startTimestamp: null,
      stopTimestamp: null,
      timerDiff: null,
      aggregatedPlaySent: false,
      stats: {
        streamTimerStartTimeMinutes: 0,
        startTimeMinutes: 0,
        endTimeMinutes: 0,
        streamTimerStarted: false,
      },
      statsObject: [],
      rangeSlider: {
        current: 0,
        start: 0,
        end: 0,
      },
    }
  },
  created() {
    window.addEventListener('resize', this.screenResized)
  },
  mounted() {
    this.initPlayer()
    this.sendTrackingDataObject(this.statsObject)
  },
  beforeDestroy() {
    event.$off('loadAudioEpisode', this.loadEpisodeAndStartPlayer)
    event.$off('showAudioPlayer', this.loadEpisodeAndShowPlayer)
    event.$off('embedPlayClicked', this.pauseAudio)
    this.player.removeEventListener('timeupdate', this.timeUpdateEventListener)
    this.player.removeEventListener('ended', this.endEventListener)
  },
  destroyed() {
    window.removeEventListener('resize', this.screenResized)
  },
  methods: {
    aggregatedPlay() {
      const episodeId = this.currentPlayObject.episode.id
      const stat = StatisticsHelper.episode(DataType.EPISODE, episodeId, ImpressionType.PLAY_IMPRESSION)
      // Player has accumulated at least 60 seconds of playtime for episodeId
      this.sendTrackingData(stat)
      this.aggregatedPlaySent = true
    },
    trackInfoClick(e) {
      if (this.viewSize !== 'fullscreen') {
        this.mediaPlayerFullscreen(e)
      }
    },
    buttonClick(button, state) {
      switch (button) {
        case 'controlPlayPause':
          this.pauseAudio()
          if (state === 'paused') {
            this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
            this.statComposer('buttonClick', PlayState.PAUSED, 'controlPlayPause')
            this.statComposer('stream')
          } else {
            this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
            this.statComposer('buttonClick', PlayState.PLAYING, 'controlPlayPause')
          }
          break
        case 'controlNext':
          this.statComposer('buttonClick', true, 'controlNext')
          this.getObjectFromList('next')
          break
        case 'controlPrev':
          this.statComposer('buttonClick', true, 'controlPrev')
          this.getObjectFromList('previous')
          break
      }
    },
    calculatePlayTime() {
      let diff
      if (!this.aggregatedPlaySent) {
        if (this.startTimestamp === null) {
          this.startTimestamp = new Date()
          // New start timestamp
          if (this.timerDiff === null) {
            // Starting first timer
            this.timer = setTimeout(() => this.aggregatedPlay(), 60000)
          } else {
            const remaining = 60000 - this.timerDiff
            this.stopTimestamp = null
            clearTimeout(this.timer)
            this.timer = setTimeout(() => this.aggregatedPlay(), remaining)
          }
        } else if (this.startTimestamp !== null && this.stopTimestamp === null) {
          this.stopTimestamp = new Date()
          diff = this.stopTimestamp - this.startTimestamp
          let oldDiff = 0
          if (this.timerDiff !== null) {
            oldDiff = this.timerDiff
          }
          const newDiff = diff + oldDiff
          this.timerDiff = newDiff
          this.startTimestamp = null
          clearTimeout(this.timer)
        }
      }
    },
    resetPlayTime() {
      // All play impression timer related data cleared
      this.stats.startTimeMinutes = 0
      this.stats.endTimeMinutes = 0
      this.timerDiff = null
      this.startTimestamp = null
      this.stopTimestamp = null
      this.aggregatedPlaySent = false
      clearTimeout(this.timer)
    },
    initPlayer() {
      this.audioPlayer = new AudioPlayer()
      this.player = document.getElementById('audioplayer')
      this.player.addEventListener('timeupdate', this.timeUpdateEventListener)
      this.player.addEventListener('ended', this.endEventListener)
      event.$on('loadAudioEpisode', this.loadEpisodeAndStartPlayer)
      event.$on('showAudioPlayer', this.loadEpisodeAndShowPlayer)
      event.$on('embedPlayClicked', this.pauseAudio)
    },
    statComposer(type, state, buttonName) {
      const episodeId = this.currentPlayObject.episode.id
      let stat
      const start = this.stats.startTimeMinutes
      const end = this.stats.endTimeMinutes
      switch (type) {
        case 'buttonClick':
          stat = StatisticsHelper.buttonClick(DataType.BUTTON, state, ImpressionType.CLICK, episodeId, buttonName)
          this.statsObject.push(stat)
          break
        case 'stream':
          if (start !== end && start < end) {
            stat = StatisticsHelper.stream(
              DataType.STREAMDURATION,
              episodeId,
              ImpressionType.STREAM_IMPRESSION,
              this.stats.startTimeMinutes,
              this.stats.endTimeMinutes,
              type
            )
            this.statsObject.push(stat)
          }
          break
        case 'stopped':
          if (start !== end && start < end) {
            stat = StatisticsHelper.stream(
              DataType.STREAMDURATION,
              episodeId,
              ImpressionType.STREAM_IMPRESSION,
              this.stats.startTimeMinutes,
              this.stats.endTimeMinutes,
              type
            )
            this.statsObject.push(stat)
          }
          break
        case 'completed':
          if (start !== end && start < end) {
            stat = StatisticsHelper.stream(
              DataType.STREAMDURATION,
              episodeId,
              ImpressionType.STREAM_IMPRESSION,
              this.stats.startTimeMinutes,
              this.stats.endTimeMinutes,
              type
            )
            this.statsObject.push(stat)
          }
          break
      }
    },
    loadEpisodeAndShowPlayer(episodeId) {
      this.loadEpisode(episodeId, false)
    },
    loadEpisodeAndStartPlayer(episodeId) {
      this.resetPlayTime()
      this.loadEpisode(episodeId, true)
    },
    loadEpisode(episodeId, startPlayer = true) {
      const enableClientSideAdInsertion = false

      let adPromise
      if (enableClientSideAdInsertion) {
        adPromise = event.$http
          .get(config.url.ads, {
            params: { episode_id: episodeId },
            headers: auth.getAuthHeader(),
          })
          .then((response) => response.body.data)
      } else {
        adPromise = Promise.resolve([])
      }

      adPromise.then(
        (ads) => {
          this.$http
            .get(config.url.episodes + '/' + episodeId, {
              params: {},
              headers: auth.getAuthHeader(),
            })
            .then(
              (response) => {
                const episode = response.body.data

                this.socialShareLink = 'https://afripods.africa/episode/' + episode.title + '/' + episode.id

                // Gets all episodes associated with podcast of chosen episode.
                this.$http
                  .get(config.url.podcasts + '/' + episode.podcast_id + '/episodes', {
                    params: {},
                    headers: auth.getAuthHeader(),
                  })
                  .then((response) => {
                    let data = response.body.data

                    // A harvested episode will not have any episodes in the playlist
                    // so just create a one item playlist of the selected episode.
                    if (data.length === 0) {
                      data = [episode]
                    }

                    // Get all play objects
                    this.playObjects = AudioPlayerUtils.getListOfPlayObjects(
                      data,
                      AudioPlayerUtils.getPreRollAds(ads),
                      AudioPlayerUtils.getMidRollAds(ads)
                    )
                    if (!startPlayer) {
                      this.waitingForFirstPlay = true
                    }
                    this.getObjectFromList(episode.id, startPlayer)
                  })
              },
              (e) => {
                this.$notify({
                  title: 'Unable to play audio',
                  text: 'Unable to play audio file from the third party, please contact us if the error persists',
                  type: 'error',
                })
              }
            )
        },
        (e) => {
          this.$log.error('Error loading episode ads', e.body)
        }
      )
    },
    /**
     * Handles selecting a playObject. whichObject can be an id for an episode.
     * Or a string such as 'NEXT' or 'PREVIOUS'
     *
     * @param whichObject
     */
    getObjectFromList(whichObject, startPlayer = true) {
      this.audioPlayer.showAudioPlayer = true

      // If user wants the next playObject in the queue
      if (whichObject === WhichObject.NEXT) {
        this.currentPlayObject = AudioPlayerUtils.getPlayObjectFromListByIndexId(
          WhichObject.NEXT,
          this.currentPlayObject,
          this.playObjects
        )
      } // If user wants the previous object in the queue
      else if (whichObject === WhichObject.PREVIOUS) {
        this.currentPlayObject = AudioPlayerUtils.getPlayObjectFromListByIndexId(
          WhichObject.PREVIOUS,
          this.currentPlayObject,
          this.playObjects
        )
      } else {
        this.currentPlayObject = AudioPlayerUtils.getPlayObjectFromListById(whichObject, this.playObjects)
      }

      this.currentObjectUpdated(startPlayer)
      if (startPlayer) {
        this.trackEpisodePlayImpression()
      }
    },
    currentObjectUpdated(startPlayer = true) {
      this.resetPlayTime()
      if (this.currentPlayObject.preRollAds.length > 0) {
        this.playPreRoll(this.currentPlayObject.preRollAds[0], startPlayer)
        if (!startPlayer) {
          this.setEpisodeMetaData()
        }
      } else {
        this.setEpisodeMetaData()
        this.playAudio(this.currentPlayObject.episode.streamUrl, 0, startPlayer)
      }
    },
    playPreRoll(preRoll, startPlayer = true) {
      this.currentPlayObject.currentObjectType = ObjectType.PRE_ROLL
      this.playAdRoll(preRoll, startPlayer)
    },
    playMidRoll(midRoll) {
      this.currentPlayObject.currentObjectType = ObjectType.MID_ROLL
      this.currentPlayObject.currentMidroll = midRoll.timestamp
      AudioPlayerUtils.removeAdFromMidrollList(this.currentPlayObject)
      this.pauseAudio()
      this.playAdRoll(midRoll)
    },
    playAdRoll(adRoll, startPlayer = true) {
      this.currentPlayObject.idOfLastPlayedAd = adRoll.id
      if (startPlayer) {
        this.setAdMetaData(adRoll)
        this.playAudio(adRoll.ad.media_file, 0, startPlayer)
        this.trackAdPlayImpression(adRoll)
      }
    },
    trackAdPlayImpression(adRoll) {
      const stat = StatisticsHelper.ad(
        DataType.AD,
        adRoll.id,
        this.currentPlayObject.episode.id,
        ImpressionType.PLAY_IMPRESSION
      )
      this.sendTrackingData(stat)

      // Old tracking
      this.oldAdImpression(adRoll.id, this.currentPlayObject.episode.id)
    },
    trackAdCompleteImpression() {
      const stat = StatisticsHelper.ad(
        DataType.AD,
        this.currentPlayObject.idOfLastPlayedAd,
        this.currentPlayObject.episode.id,
        ImpressionType.COMPLETE_IMPRESSION
      )
      this.sendTrackingData(stat)
    },
    trackEpisodeCompleteImpression(adId) {
      const stat = StatisticsHelper.episode(
        DataType.EPISODE,
        this.currentPlayObject.episode.id,
        ImpressionType.COMPLETE_IMPRESSION
      )
      this.sendTrackingData(stat)
    },
    trackEpisodePlayImpression() {
      const episodeId = this.currentPlayObject.episode.id
      const episodeTitle = this.currentPlayObject.episode.title
      this.calculatePlayTime()
      this.$ga.event({
        eventCategory: 'Episode',
        eventAction: 'play',
        eventLabel: episodeTitle,
        eventValue: episodeId,
      })
    },
    setEpisodeMetaData() {
      this.view = window.innerWidth > 991 ? 'desktop' : 'mobile'
      this.audioPlayer.speed = 3
      this.audioPlayer.speedRadio = 3
      this.audioPlayer.playerElement = document.getElementById('audio-player')
      this.audioPlayer.author = this.currentPlayObject.episode.podcast_title
      this.audioPlayer.episodeIndex = this.currentPlayObject.episode.number
      this.currentPlayObject.currentObjectType = ObjectType.EPISODE
      this.audioPlayer.title = this.currentPlayObject.episode.title
      this.audioPlayer.image = isValidUrl(this.currentPlayObject.episode.image)
        ? this.currentPlayObject.episode.image
        : config.image.episode.thumb + this.currentPlayObject.episode.image
      this.audioPlayer.durationInSeconds = Number(this.currentPlayObject.episode.duration)
      this.audioPlayer.playerEpisodeDuration = trackDuration(this.currentPlayObject.episode.duration)
      this.checkUserSave()
      event.$emit('audioPlayerEpisodeLoaded', this.currentPlayObject.episode)
    },
    setAdMetaData(adRoll) {
      this.audioPlayer.currentTimeInSeconds = 0
      this.audioPlayer.durationInSeconds = Number(adRoll.ad.duration)
      this.audioPlayer.playerEpisodeDuration = trackDuration(adRoll.ad.duration)
      this.audioPlayer.title = 'AD - ' + adRoll.ad.title
      this.audioPlayer.author = this.currentPlayObject.episode.author
      this.audioPlayer.image = config.image.ad.thumb + adRoll.ad.image
    },
    /**
     * Handles starting a track from a particular time point.
     * @param url
     * @param time
     * @param startPlayer
     */
    playAudio(url, time, startPlayer = true) {
      if (document.getElementById('afripods-content') !== null) {
        const contentWrapperId = document.getElementById('afripods-content')
        if (!contentWrapperId.classList.contains('media-player-open')) {
          contentWrapperId.classList.add('media-player-open')
        }
      }
      let decoratedUrl = url

      if (url.indexOf(config.url.media) !== -1) {
        // eslint-disable-next-line no-undef
        const listenerId =
          typeof com_adswizz_synchro_getListenerId === 'function' && com_adswizz_synchro_getListenerId() // From Adswizz library loaded as a script tag.
        if (listenerId) {
          try {
            const parsedUrl = new URL(url)
            parsedUrl.searchParams.append('listenerId', listenerId)
            decoratedUrl = parsedUrl.toString()
          } catch (ignored) {
            // Ignored - just continuing without a listenerId
          }
        }
      }

      if (startPlayer) {
        this.currentPlayObject.playState = PlayState.PLAYING
        AudioPlayerUtils.playAudio(this.player, decoratedUrl, time)
        this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
      } else {
        this.player.src = decoratedUrl
        this.player.preload = 'none'
        this.player.currentTime = time
        this.currentPlayObject.playState = PlayState.PAUSED
      }
      event.$emit('audioPlayerPlayStateChanged', this.currentPlayObject.playState)
    },
    pauseAudio() {
      this.calculatePlayTime()
      if (this.currentPlayObject.playState === PlayState.PLAYING) {
        this.player.pause()
        this.currentPlayObject.playState = PlayState.PAUSED
      } else if (this.currentPlayObject.playState === PlayState.PAUSED) {
        if (this.waitingForFirstPlay) {
          // player wasn't started with auto play => need to track play impressions and updating metadata for the pre roll
          this.waitingForFirstPlay = false
          this.trackEpisodePlayImpression()
          if (this.currentPlayObject.currentObjectType === ObjectType.PRE_ROLL) {
            const adRoll = this.currentPlayObject.preRollAds[0]
            this.setAdMetaData(adRoll)
            this.trackAdPlayImpression(adRoll)
          }
        }
        this.player.play()
        this.currentPlayObject.playState = PlayState.PLAYING
        this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
      }
      event.$emit('audioPlayerPlayStateChanged', this.currentPlayObject.playState)
    },
    volumeControl() {
      this.player.volume = this.audioPlayer.volume / 100
    },
    speedControl() {
      switch (this.audioPlayer.speed) {
        case '1':
          this.player.playbackRate = '0.5'
          this.audioPlayer.speedRadio = '1'
          break
        case '2':
          this.player.playbackRate = '0.75'
          this.audioPlayer.speedRadio = '2'
          break
        case '3':
          this.player.playbackRate = '1'
          this.audioPlayer.speedRadio = '3'
          break
        case '4':
          this.player.playbackRate = '1.25'
          this.audioPlayer.speedRadio = '4'
          break
        case '5':
          this.player.playbackRate = '1.5'
          this.audioPlayer.speedRadio = '5'
          break
        case '6':
          this.player.playbackRate = '1.75'
          this.audioPlayer.speedRadio = '6'
          break
        case '7':
          this.player.playbackRate = '2'
          this.audioPlayer.speedRadio = '7'
          break
        case '8':
          this.player.playbackRate = '2.5'
          this.audioPlayer.speedRadio = '8'
          break
        case '9':
          this.player.playbackRate = '3'
          this.audioPlayer.speedRadio = '9'
          break
        default:
          this.player.playbackRate = '1'
          this.audioPlayer.speedRadio = '3'
      }
    },
    speedControlToggle(val) {
      this.audioPlayer.speed = val
      this.audioPlayer.speedRadio = val
      this.speedControl()
    },
    rangeSliderEvent(event) {
      switch (event) {
        case 'start':
          this.rangeSlider.start = this.rangeSlider.current
          //TODO: Stats for dragstart (?)
          break
        case 'stop':
          this.rangeSlider.end = this.rangeSlider.current
          //TODO: Stats for dragend (?)
          break
        case 'click':
          this.rangeSlider.current
          this.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
          break
      }
    },
    seekSelect() {
      if (
        this.audioPlayer.currentTimeInSeconds < this.audioPlayer.durationInSeconds &&
        this.currentPlayObject.currentObjectType === ObjectType.EPISODE
      ) {
        this.audioPlayer.currentTimeInSeconds = this.rangeSlider.current
        AudioPlayerUtils.seekTo(this.player, this.audioPlayer.currentTimeInSeconds)
      }
    },
    /**
     *
     * This function listens for when an audio file plays until the end. When this occurs an end event occurs and executes the appropriate methods.
     *
     */
    listenForEndEvent(player) {
      this.player.addEventListener('ended', () => {
        if (this.currentPlayObject.currentObjectType === ObjectType.MID_ROLL) {
          this.trackAdCompleteImpression()
          this.pauseAudio()
          this.setEpisodeMetaData()
          this.audioPlayer.currentTimeInSeconds = Math.floor(this.currentPlayObject.currentMidroll)
          this.playAudio(this.currentPlayObject.episode.streamUrl, this.currentPlayObject.currentMidroll)
        } else if (this.currentPlayObject.currentObjectType === ObjectType.PRE_ROLL) {
          this.trackAdCompleteImpression()
          this.pauseAudio()
          this.setEpisodeMetaData()
          this.playAudio(this.currentPlayObject.episode.streamUrl, 0)
        } else if (this.currentPlayObject.currentObjectType === ObjectType.EPISODE) {
          this.trackEpisodeCompleteImpression()
          this.pauseAudio()
          this.getObjectFromList(WhichObject.NEXT)
        }
      })
    },
    endEventListener() {
      if (this.currentPlayObject.currentObjectType === ObjectType.MID_ROLL) {
        this.trackAdCompleteImpression()
        this.pauseAudio()
        this.setEpisodeMetaData()
        this.audioPlayer.currentTimeInSeconds = Math.floor(this.currentPlayObject.currentMidroll)
        this.playAudio(this.currentPlayObject.episode.streamUrl, this.currentPlayObject.currentMidroll)
      } else if (this.currentPlayObject.currentObjectType === ObjectType.PRE_ROLL) {
        this.trackAdCompleteImpression()
        this.pauseAudio()
        this.setEpisodeMetaData()
        this.playAudio(this.currentPlayObject.episode.streamUrl, 0)
      } else if (this.currentPlayObject.currentObjectType === ObjectType.EPISODE) {
        this.trackEpisodeCompleteImpression()
        this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
        this.statComposer('completed')
        this.pauseAudio()
        this.stats.startTimeMinutes = 0
        this.getObjectFromList(WhichObject.NEXT)
      }
    },
    closePlayer() {
      this.audioPlayer.showAudioPlayer = false
      if (this.currentPlayObject.playState === PlayState.PLAYING) {
        this.player.pause()
        this.currentPlayObject.playState = PlayState.PAUSED
        this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60)
        this.statComposer('stopped')
      }
      if (
        this.audioPlayer.playerElement !== undefined &&
        this.audioPlayer.playerElement !== null &&
        this.audioPlayer.playerElement.classList.contains('fullscreen')
      ) {
        this.audioPlayer.playerElement.classList.remove('fullscreen')
      }
      this.viewSize = 'default'
      if (document.getElementById('afripods-content') !== null) {
        document.getElementById('afripods-content').classList.remove('media-player-open')
      }
    },
    /**
     * Listens for the track time and performs actions required to be done while an episode is playing. Mainly updates the player timer
     * and if there are midroll ads it listens for the time points of these ads, and will play the ad if necessary.
     *
     * @param player
     */
    listenForTimePoints(player) {
      player.addEventListener('timeupdate', this.timeUpdateEventListener)
    },
    timeUpdateEventListener(event) {
      this.audioPlayer.currentTimeInSeconds = Math.floor(this.player.currentTime)
      this.rangeSlider.current = Math.floor(this.player.currentTime)
      this.audioPlayer.playerEpisodeCurrentTime = trackDuration(this.player.currentTime)

      if (this.currentPlayObject.currentObjectType === ObjectType.EPISODE) {
        const midRoll = this.currentPlayObject.midRollads.find((midRollAd, index) => {
          return AudioPlayerUtils.isMidRollPoint(this.player.currentTime, midRollAd)
        })
        if (midRoll) {
          this.playMidRoll(midRoll)
        }
      }
    },
    sendTrackingData(stat) {
      afripodsHttp
        .createTrackingData(stat)
        .then((res) => res)
        .catch((e) => this.$log.debug('** Afripods error on sendTrackingData(): ', e))
    },
    sendTrackingDataObject(object) {
      const self = this
      setTimeout(function () {
        if (object.length > 0) {
          afripodsHttp
            .createListOfTrackingData(object)
            .then((res) => res)
            .catch((e) => this.$log.debug('** Afripods error on sendTrackingDataObject(): ', e))
          self.statsObject = []
        }
        self.sendTrackingDataObject(self.statsObject)
      }, 30000)
    },
    oldEpisodeImpression(episodeId) {
      this.$http.post(config.url.episodes + '/' + episodeId + '/play', {}, { headers: auth.getAuthHeader() }).then(
        function (response) {},
        function (e) {
          this.$log.debug('Error sending ad impression to server ' + e.body.message)
        }
      )
    },
    oldAdImpression(scheduleAdId, episodeId) {
      this.$http
        .post(
          config.url.ads + '?scheduled_ad_id=' + scheduleAdId + '&episode_id=' + episodeId,
          {},
          { headers: auth.getAuthHeader() }
        )
        .then(
          function (response) {},
          function (e) {
            this.$log.debug('Error sending episode impression to server ' + e.body.message)
          }
        )
    },
    mediaPlayerFullscreen(e) {
      if (
        window.innerWidth < 992 &&
        window.innerHeight > 567 &&
        !document.getElementById('audio-player').classList.contains('fullscreen') &&
        window === window.parent
      ) {
        this.audioPlayer.playerElement = document.getElementById('audio-player')

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          if (this.audioPlayer.playerElement.requestFullscreen) {
            this.audioPlayer.playerElement.requestFullscreen()
          } else if (this.audioPlayer.playerElement.webkitRequestFullscreen) {
            /* Safari */
            this.audioPlayer.playerElement.webkitRequestFullscreen()
          } else if (this.audioPlayer.playerElement.msRequestFullscreen) {
            /* IE11 */
            this.audioPlayer.playerElement.msRequestFullscreen()
          }
          this.audioPlayer.playerElement.className += ' fullscreen'
          this.viewSize = 'fullscreen'
        }
      }
    },
    screenResized() {
      if (window.innerWidth > 991) {
        this.view = 'desktop'
        if (document.exitFullscreen && document.fullscreenElement !== null) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen && document.fullscreenElement !== null) {
          /* Safari */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen && document.fullscreenElement !== null) {
          /* IE11 */
          document.msExitFullscreen()
        }
        if (
          this.audioPlayer.playerElement !== undefined &&
          this.audioPlayer.playerElement !== null &&
          this.audioPlayer.playerElement.classList.contains('fullscreen')
        ) {
          this.audioPlayer.playerElement.classList.remove('fullscreen')
        }
        this.viewSize = 'default'
      } else {
        this.view = 'mobile'
      }
    },
    minimizeFullscreen() {
      this.audioPlayer.playerElement.classList.remove('fullscreen')
      this.viewSize = 'default'
      if (document.exitFullscreen && document.fullscreenElement !== null) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen && document.fullscreenElement !== null) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen && document.fullscreenElement !== null) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },
    mobileSpeedMenu() {
      const speedMenu = document.getElementById('speed-menu')
      speedMenu.classList.add('open')
    },
    mobileShareMenu() {
      const mobileShareMenu = document.getElementById('mobile-share-menu')
      mobileShareMenu.classList.add('open')
    },
    speedMenuClose() {
      const speedMenu = document.getElementById('speed-menu')
      speedMenu.classList.remove('open')
    },
    shareMenuClose() {
      const shareMenu = document.getElementById('mobile-share-menu')
      shareMenu.classList.remove('open')
    },
    copyUrl() {
      const dummy = document.createElement('input')
      const text = window.location.href
      document.body.appendChild(dummy)
      dummy.value = text
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)
      alert('Link copied to clipboard')
    },
    checkUserSave: function () {
      const userBookmarks = localStorage.getItem('userBookmarks')
      const savedEpisodes = userBookmarks ? JSON.parse(userBookmarks) : []
      this.episodeSaved = !!savedEpisodes.some((el) => el.id === this.currentPlayObject.episode.id)
    },
    handleSave: function () {
      const self = this
      this.user.userId = auth.getLoggedInUserId()
      if (this.user.userId === null) {
        $('#promptModal').modal('show')
      } else {
        // handle save function
        if (!this.episodeSaved) {
          this.sendStatistics('save', this.currentPlayObject.episode.id)
          this.$http
            .post(
              config.url.episodes + '/' + this.currentPlayObject.episode.id + '/save',
              {},
              { headers: auth.getAuthHeader() }
            )
            .then(
              function (response) {
                self.episodeSaved = true
                this.$http
                  .get(config.url.listener_dashboard, {
                    params: {},
                    headers: auth.getAuthHeader(),
                  })
                  .then(function (response) {
                    const data = response.body.data
                    localStorage.setItem('userShows', JSON.stringify(data.shows))
                    localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks))
                    localStorage.setItem('userEpisodes', data.episodes)
                  })
              },
              function (e) {
                this.$notify({
                  title: 'Error',
                  text: this.getErrorMessage(e),
                  type: 'error',
                })
              }
            )
        } else {
          this.sendStatistics('saveRemoved', this.currentPlayObject.episode.id)
          this.$http
            .delete(config.url.episodes + '/' + this.currentPlayObject.episode.id + '/save', {
              params: {},
              headers: auth.getAuthHeader(),
            })
            .then(
              function (response) {
                self.episodeSaved = false
                this.$http
                  .get(config.url.listener_dashboard, {
                    params: {},
                    headers: auth.getAuthHeader(),
                  })
                  .then(function (response) {
                    const data = response.body.data
                    localStorage.setItem('userShows', JSON.stringify(data.shows))
                    localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks))
                    localStorage.setItem('userEpisodes', data.episodes)
                  })
              },
              function (e) {
                this.$notify({
                  title: 'Error',
                  text: this.getErrorMessage(e),
                  type: 'error',
                })
              }
            )
        }
      }
    },
    sendStatistics: function (type, id) {
      let stat
      switch (type) {
        case 'save':
          this.checkUserFollowEpisodePodcast()
          stat = StatisticsHelper.episodeSave('favouriteUpdate', true, this.user.podcastFollowed, id, 'audioplayer')
          break
        case 'saveRemoved':
          this.checkUserFollowEpisodePodcast()
          stat = StatisticsHelper.episodeSave('favouriteUpdate', false, this.user.podcastFollowed, id, 'audioplayer')
          break
      }
      this.sendTrackingData(stat)
    },
    checkUserFollowEpisodePodcast: function () {
      const userShows = localStorage.getItem('userShows')
      const followedShows = userShows ? JSON.parse(userShows) : []
      const following = followedShows.some((el) => el.id === this.currentPlayObject.episode.podcast_id)
      this.user.podcastFollowed = following
    },
    goToPodcast() {
      if (this.view === 'mobile' && this.viewSize === 'default') return
      const podcast = {
        id: this.currentPlayObject.episode.podcast_id.toString(),
        slug: this.currentPlayObject.episode.podcast_slug,
      }

      this.$router.push({ name: 'Podcast', params: { slug: podcast.slug || podcast.id } })
      if (this.view === 'mobile' && this.viewSize === 'fullscreen') {
        this.minimizeFullscreen()
      }
    },
  },
}
</script>
<style lang="scss">
.audio-player {
  .vue-slider {
    .vue-slider-rail {
      background-color: #ccc;

      @media (min-width: 992px) {
        border-radius: 15px;
      }
    }

    .vue-slider-process {
      @media (min-width: 992px) {
        border-radius: 15px;
      }
    }

    .vue-slider-dot-handle {
      margin-top: 1px;
      border-radius: 50%;
      box-shadow: 0.5px 0.5px 2px 1px rgb(0 0 0 / 32%);
    }
  }
}
</style>
<style lang="scss" scoped>
.audio-player {
  .volume-slider {
    .volume-slider-range {
      left: 20px;
      margin-bottom: 70px;
      transform: rotate(-90deg) translateY(-70%);
    }

    .speed-menu {
      left: 50%;
      margin-left: 0 !important;
      transform: translateX(-50%);
    }
  }

  .mobile-audioplayer-fullscreen {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 47px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AudioPlayer/AudioPlayer.vue